import { selectIsVendor } from "features/user/userSlice";
import { useSelector } from "react-redux";
import { Redirect, useLocation } from "react-router-dom";

// Vendor: confined to the mechanical dashboard.
const VENDOR_ALLOWED_PATHS = ["/dashboard/mechanical", "/workorder"];
// Auth / account-utility routes a vendor must still reach (login callback, logout, password flows).
const VENDOR_EXCLUDED_PATHS = ["/logout", "/callback", "/confirm", "/changePassword", "/resetpassword"];

// To confine another role, add its own ALLOWED/EXCLUDED lists above and a matching block below.

const matchesPath = (pathname, paths) => paths.some((path) => pathname.startsWith(path));

const RestrictedRoute = ({ children }) => {
    const isVendor = useSelector(selectIsVendor);
    const { pathname } = useLocation();

    if (isVendor && !matchesPath(pathname, VENDOR_ALLOWED_PATHS) && !matchesPath(pathname, VENDOR_EXCLUDED_PATHS)) {
        return <Redirect to={VENDOR_ALLOWED_PATHS[0]} />;
    }

    return children;
};

export default RestrictedRoute;
